/* ChasingCards — FAQ-Seite: Kategorie-Filter (Tabs inkl. „Alle") + Live-Suche
   + Trefferzähler + Empty-State. Accordion = natives <details>/<summary>
   (built-in Tastatur/Fokus); aria-expanded wird zusätzlich synchron gehalten.
   Progressiv: ohne JS sind alle Fragen sichtbar. */
(function () {
  var root = document.querySelector('.cc-page-faq');
  if (!root) return;

  var tabs = [].slice.call(root.querySelectorAll('[data-cc-faq-tab]'));
  var groups = [].slice.call(root.querySelectorAll('[data-cc-faq-group]'));
  var items = [].slice.call(root.querySelectorAll('[data-cc-faq-item]'));
  var searchInput = root.querySelector('[data-cc-faq-search]');
  var countEl = root.querySelector('[data-cc-faq-count]');
  var emptyEl = root.querySelector('[data-cc-faq-empty]');

  var activeCat = 'all';
  var query = '';

  function updateCount(n) {
    if (!countEl) return;
    countEl.textContent = n + (n === 1 ? ' Frage' : ' Fragen');
  }

  function apply() {
    var visible = 0;
    groups.forEach(function (group) {
      var slug = group.getAttribute('data-cc-faq-group');
      var catMatch = activeCat === 'all' || activeCat === slug;
      var groupHas = false;
      [].slice.call(group.querySelectorAll('[data-cc-faq-item]')).forEach(function (item) {
        var textMatch = !query || (item.getAttribute('data-search') || '').indexOf(query) !== -1;
        var show = catMatch && textMatch;
        item.hidden = !show;
        if (show) { groupHas = true; visible++; }
      });
      group.hidden = !groupHas;
    });
    if (emptyEl) emptyEl.hidden = visible !== 0;
    updateCount(visible);
  }

  /* Filter-Tabs */
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activeCat = tab.getAttribute('data-cc-faq-tab');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply();
    });
  });

  /* Live-Suche */
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      query = searchInput.value.trim().toLowerCase();
      apply();
    });
  }

  /* aria-expanded am <summary> synchron zum <details>-Zustand halten */
  items.forEach(function (item) {
    var summary = item.querySelector('summary');
    if (!summary) return;
    var sync = function () { summary.setAttribute('aria-expanded', item.open ? 'true' : 'false'); };
    sync();
    item.addEventListener('toggle', sync);
  });

  apply();
})();
